<template>
  <v-dialog v-model="dialog" width="40rem" persistent scrollable>
    <v-card>
      <v-toolbar color="primary white--text" flat>
        <sabira_icon
          icon="email_invoice"
          size="42"
          class="mr-3"
          :strokewidth="3"
          fill="white"
        />
        <v-toolbar-title>Elektronsko slanje dokumenata</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4">
        <v-subheader class="ml-0 pl-0">
          Pošiljalac
        </v-subheader>
        <div
          style="display:grid;grid-column-gap: 1rem;grid-template-columns: max-content 1fr;"
        >
          <div>{{ active_item.sender.name }}</div>
          <div>&#60;{{ active_item.sender.email }}&#62;</div>
        </div>

        <v-text-field
          hide-details
          outlined
          class="mt-2"
          label="Naslov"
          v-model="active_item.subject"
        ></v-text-field>

        <v-subheader class="ml-0 pl-0">
          Primalac
        </v-subheader>
        <div
          v-for="(recipient, index) in active_item.recipients"
          :key="'r_' + index"
          class="mb-2"
          style="display: grid; grid-column-gap: 1rem; grid-template-columns: 1fr 1fr; align-items:center;"
        >
          <div
            style="display: grid; grid-template-columns:max-content 1fr;align-items:center;"
          >
            <v-btn v-if="index > 0" icon @click="remove_recipient(index)"
              ><sabira_icon icon="trash"
            /></v-btn>
            <div v-else>&nbsp;</div>
            <v-text-field
              outlined
              hide-details
              label="Naziv primaoca"
              v-model="recipient.name"
            >
            </v-text-field>
          </div>
          <div
            style="display:grid;grid-template-columns: 1fr max-content; align-items:center;"
          >
            <v-text-field
              hide-details
              type="email"
              :rules="[rules.email.regex]"
              outlined
              label="Email primaoca"
              v-model="recipient.email"
            >
              <template v-slot:prepend-inner>
                <sabira_icon class="mr-2" icon="at-sign" />
              </template>
            </v-text-field>
            <v-btn
              icon
              v-if="index == recipients.length - 1"
              @click="add_recipient()"
              ><sabira_icon icon="plus"></sabira_icon
            ></v-btn>
          </div>
        </div>

        <v-textarea
          class="mt-4"
          label="Poruka"
          hide-details
          clearable
          outlined
          v-model="active_item.message"
        >
        </v-textarea>

        <v-subheader class="ml-0 pl-0">
          Prilog
        </v-subheader>
        <v-chip
          :key="'a_' + index"
          v-for="(attachment, index) in active_item.attachments"
          label
          class="pl-2"
          color="primary"
        >
          <sabira_icon
            :width="20"
            class="left mr-2"
            fill="white"
            icon="file-pdf"
          />
          {{ attachment.filename }}
        </v-chip>
      </v-card-text>
      <v-card-actions class="background">
        <v-btn text @click="close_dialog()">Odustani</v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="is_loading" text @click="send_email()">{{
          $t("send")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    subject: {
      type: String,
      default: null,
    },
    sender: {
      type: Object,
      default: null,
    },
    recipients: {
      type: Array,
      default: () => [],
    },
    message: {
      type: String,
      default: null,
    },
    attachments: {
      type: Array,
      default: () => [],
    },
    close: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      is_loading: false,
      dialog: false,
      active_item: {
        subject: null,
        recipients: [],
        sender: null,
        attachments: [],
        message: null,
      },
      rules: {
        email: {
          required: (v) => !!v || "Obavezno.",
          regex: (v) =>
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            "E-mail adresa mora biti validna.",
        },
      },
    };
  },
  watch: {
    visible: {
      handler() {
        this.dialog = this.visible;
      },
      immediate: true,
    },
    subject: {
      handler() {
        this.active_item.subject = this.subject;
      },
      immediate: true,
    },
    sender: {
      handler() {
        this.active_item.sender = this.sender;
      },
      immediate: true,
    },
    recipients: {
      handler() {
        this.active_item.recipients = this.recipients;
      },
      immediate: true,
    },
    message: {
      handler() {
        this.active_item.message = this.message;
      },
      immediate: true,
    },
    attachments: {
      handler() {
        this.active_item.attachments = this.attachments;
      },
      immediate: true,
    },
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (this.recipient.email == null || this.recipient.email.lenght == 0) {
          has_errors = true;
          reject("Email adresa primaoca je obavezna");
        }
        if (!has_errors) {
          resolve();
        }
      });
    },
    close_dialog() {
      this.$webpageEventBus.$emit(this.close);
    },
    remove_recipient(index) {
      this.recipients.splice(index, 1);
    },
    add_recipient() {
      this.active_item.recipients.push({ name: null, email: null });
    },
    send_email() {
      this.is_loading = true;
      var message = {
        subject: this.active_item.subject,
        recipients: this.active_item.recipients,
        message: this.active_item.message,
        sender: this.active_item.sender,
        template: "default",
        attachments: this.active_item.attachments,
        account_logo: this.$store.getters.user.account_logo,
      };

      this.$http({
        method: "POST",
        url: process.env.VUE_BASE_MAILER_URL,
        data: message,
      })
        .then((resp) => {
          if (resp.status == 200) {
            this.$webpageEventBus.$emit("show_status", {
              type: "success",
              message: "Poruka uspješno poslana",
              timeout: 2000,
            });
            this.close_dialog();
          } else {
            this.$webpageEventBus.$emit("show_status", {
              type: "error",
              message: "Greška prilikom slanja poruke",
              timeout: 2000,
            });
          }
        })
        .catch((error) => {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: error,
            timeout: 4000,
          });
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
  },
};
</script>
